export default function RentalProcess() {
  const steps = [
    {
      number: "01",
      title: "Browse & Select",
      description:
        "Explore our comprehensive catalog and add items to your rental cart",
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path
            d="M8 8H40M8 24H40M8 40H40"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      ),
    },
    {
      number: "02",
      title: "Generate Invoice",
      description:
        "Submit your selection with event details and receive a detailed invoice",
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <rect
            x="8"
            y="12"
            width="32"
            height="28"
            rx="2"
            stroke="currentColor"
            strokeWidth="3"
          />
          <path
            d="M16 20H32M16 28H24"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      ),
    },
    {
      number: "03",
      title: "Confirm & Schedule",
      description:
        "Admin confirms your invoice, then schedule delivery or pickup for your event",
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <rect
            x="8"
            y="10"
            width="32"
            height="30"
            rx="2"
            stroke="currentColor"
            strokeWidth="3"
          />
          <path
            d="M16 8V12M32 8V12M8 18H40"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <path
            d="M18 26L22 30L30 22"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      number: "04",
      title: "Event Success",
      description:
        "We deliver, set up (if requested), and handle pickup after your event",
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle
            cx="24"
            cy="24"
            r="16"
            stroke="currentColor"
            strokeWidth="3"
          />
          <path
            d="M16 24L22 30L32 18"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
  ];

  return (
    <section className="py-20 md:py-28 px-6 bg-white dark:bg-[#121212]">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-20 text-center">
          <h2
            className="text-black dark:text-white font-medium font-serif mb-4"
            style={{
              fontSize: "clamp(32px, 5vw, 56px)",
            }}
          >
            How It Works
          </h2>
          <p className="text-[#666666] dark:text-[#A0A0A0] text-lg max-w-2xl mx-auto">
            A seamless rental experience from start to finish
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative group p-8 bg-white dark:bg-[#1E1E1E] rounded-2xl border border-[#E9E9E9] dark:border-[#333333] transition-all hover:border-[#62397f] hover:shadow-xl transform hover:-translate-y-2"
            >
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-[#62397f] to-[#7C3AED] rounded-full flex items-center justify-center text-white font-bold shadow-lg">
                {step.number}
              </div>
              <div className="mb-6 text-[#62397f]">{step.icon}</div>
              <h3 className="text-xl font-bold mb-3 text-black dark:text-white">{step.title}</h3>
              <p className="text-[#666666] dark:text-[#A0A0A0]">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
